import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@mui/material/Grid';
import { Button, IconButton, Input, InputLabel, MenuItem, Select } from '@material-ui/core';
import axios from 'axios';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import SelectAll from '@mui/icons-material/SelectAll'
import '../css/login.css'
import { LocalizationProvider, MobileDatePicker, MobileTimePicker } from '@mui/x-date-pickers';

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/schedule/create";


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));



function getSteps() {
    return ['Cita Medica'];
}

function getStepContent(stepIndex, props, body, handleChange, handleChangeDate, setBody) {

    switch (stepIndex) {

        case 0:
            return (<div>

                <Grid container className="container">
                    <Grid item xs={12} sm={6} md={4}>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='medicalDate'
                                name='medicalDate'
                                label="fecha cita"
                                inputFormat="MM/dd/yyyy"
                                value={body.medicalDate}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>

                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={4}>
                    <TextField id="patient" label="Paciente" value={body.patient?.firstName ? body.patient?.firstName + " " + body.patient?.lastName: ''}  disabled={true}  display="inline"/>
                        <label htmlFor="icon-button-file">
                            <IconButton color="primary" aria-label="Selec Paciente" component="span" onClick={() => {
                                props.setComeFromMenu(false);
                                props.setReturnPageId(11);
                                props.changeMenu(3)
                            }}>
                                <SelectAll />
                            </IconButton>
                        </label>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <TextField id="medicalTeam" label="Medico" value={body.medicalTeam?.firstName ?body.medicalTeam?.firstName + " " + body.medicalTeam?.lastName: ''}  disabled={true}  display="inline"/>

                        <label htmlFor="icon-button-file">
                            <IconButton color="primary" aria-label="Selec Medico" component="span" onClick={() => {
                                props.setComeFromMenu(false);
                                props.changeMenu(4);
                            }}>
                                <SelectAll />
                            </IconButton>
                        </label>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={4}>

                        <InputLabel id="typeDateLabel">Tipo de cita</InputLabel>
                        <Select
                            labelId="typeDateLabel"
                            id="typeDate"
                            name="typeDate"
                            value={body.typeDate}
                            onChange={handleChange}
                            label="Tipo Cita"
                        >
                            <MenuItem value={"0"}>
                                <em>Seleccionar tipo de servicio</em>
                            </MenuItem>
                            <MenuItem value="1RA VEZ">1RA VEZ</MenuItem>
                            <MenuItem value="CONTROL">CONTROL</MenuItem>
                            <MenuItem value="PERIODICO">PERIODICO</MenuItem>
                            <MenuItem value="RETIRO">RETIRO</MenuItem>
                            <MenuItem value="INGRESO">INGRESO</MenuItem>
                            <MenuItem value="INGRESO OSTEOMUSCULAR">INGRESO OSTEOMUSCULAR</MenuItem>
                            <MenuItem value="INGRESO EN ALTURA">INGRESO EN ALTURA</MenuItem>
                            <MenuItem value="PERIODICO OSTEOMUSCULAR">PERIODICO OSTEOMUSCULAR</MenuItem>
                            <MenuItem value="PERIODICO EN ALTURA">PERIODICO EN ALTURA</MenuItem>
                            <MenuItem value="RETIRO OSTEOMUSCULAR">RETIRO OSTEOMUSCULAR</MenuItem>
                            <MenuItem value="POSINCAPACIDAD">POSINCAPACIDAD</MenuItem>
                            <MenuItem value="REUBICACION LABORAL">REUBICACION LABORAL</MenuItem>
                        </Select>


                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>

                        <InputLabel id="purposeLabel">Finalidad</InputLabel>
                        <Select
                            labelId="purposeLabel"
                            id="purpose"
                            name="purpose"
                            value={body.purpose}
                            onChange={handleChange}
                            label="Finalidad"
                        >
                            <MenuItem value={"0"}>
                                <em>Seleccionar servicio</em>
                            </MenuItem>
                            <MenuItem value="MEDICINA GENERAL">MEDICINA GENERAL</MenuItem>
                            <MenuItem value="TERAPIA">TERAPIA </MenuItem>
                            <MenuItem value="NUTRICIONISTA">NUTRICIONISTA</MenuItem>
                            <MenuItem value="PEDIATRIA">PEDIATRIA</MenuItem>

                            <MenuItem value="ATENCION RIESGO CARDIOVASCULAR">ATENCION RIESGO CARDIOVASCULAR</MenuItem>
                            <MenuItem value="PROMOCION Y PREVENCION">PROMOCION Y PREVENCION</MenuItem>
                            <MenuItem value="TOMA DE MUESTRA DE LABORATORIO">TOMA DE MUESTRA DE LABORATORIO</MenuItem>
                            <MenuItem value="CONSULTA MÉDICA DOMICILIARIA">CONSULTA MÉDICA DOMICILIARIA</MenuItem>
                            <MenuItem value="ASISTENCIA MEDICA TELEFONICA">ASISTENCIA MEDICA TELEFONICA</MenuItem>
                            <MenuItem value="MEDICINA INTERNA">MEDICINA INTERNA</MenuItem>
                            <MenuItem value="VISIOMETRIA">VISIOMETRIA</MenuItem>
                            <MenuItem value="AUDIOMETRIA">AUDIOMETRIA</MenuItem>
                            <MenuItem value="ESPIROMETRIA">ESPIROMETRIA</MenuItem>
                            <MenuItem value="CONCEPTO DE APTITUD">CONCEPTO DE APTITUD</MenuItem>
                            <MenuItem value="EVALUACION MEDICA DE TRABAJO EN ALTURAS">EVALUACION MEDICA DE TRABAJO EN ALTURAS</MenuItem>


                        </Select>


                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileTimePicker
                                label="Hora inicial:"
                                value={body.starHour}
                                onChange={(newValue) => {
                                    setBody({
                                        ...body,
                                        ["starHour"]: newValue
                                    })
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileTimePicker
                                label="Hora final"
                                value={body.endHour}
                                onChange={(newValue) => {
                                    setBody({
                                        ...body,
                                        ["endHour"]: newValue
                                    })
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>

                    
                </Grid>

            </div>);

        default:
            return 'Unknown stepIndex';
    }
}


function CreateAgenda(props) {
    const classes = useStyles();
    const [body, setBody] = useState({

        patient: props.affiliateInfo,
        medicalTeam: props.medical,
        medicalDate: new Date(),
        starHour: new Date(),
        endHour: new Date(),
        purpose: "0",
        typeDate: "0"

    })

    const [activeStep, setActiveStep] = React.useState(0);
    const [openLoader, setOpenLoader] = React.useState(false);

    const steps = getSteps();

    const handleChange = e => {
        setBody({
            ...body,
            [e.target.name]: e.target.value
        })
    }

    const handleChangeDate = (newValue) => {
        setBody({
            ...body,
            ["medicalDate"]: newValue
        })
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>{getStepContent(activeStep, props, body, handleChange, handleChangeDate, setBody)}</div>


            <div>

                <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={"buttonBack"}>
                        Back
                    </Button>
                    <Button variant="contained" className="buttonNext"
                        color="primary" onClick={() => {

                            if (activeStep === steps.length - 1) {
                                setOpenLoader(true);
                                axios.post(url, body).then(response => {

                                    setOpenLoader(false);
                                    props.changeMenu(1);


                                });
                            } else {
                                handleNext();
                            }
                        }}>
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </div>


            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openLoader}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default CreateAgenda;